import WcsFeaturedProductsCarousel from '@/scripts/libs/wcs/featured-products-carousel'
import AlgoliaFeaturedProductsCarousel from '@/scripts/libs/algolia/featured-products-carousel'
import { PlpProduct } from '@/types/plp'

export interface FeaturedProductsCarouselHelper {
  fetchFeaturedProducts(_: {
    catalogEntries?: string
    partNumber: string
    algoliaRecommandation: { type: 'frequentlyBoughtTogether' | 'relatedProducts'; context: string }
    fetchAndAddProductAvailability: (_catEntryId: string) => void
  }): Promise<PlpProduct[]>
}
class FeaturedProductsCarousel implements FeaturedProductsCarouselHelper {
  fetchFeaturedProducts({
    algoliaRecommandation,
    partNumber,
    catalogEntries,
    fetchAndAddProductAvailability,
  }: {
    catalogEntries: string
    partNumber: string
    algoliaRecommandation: { type: 'frequentlyBoughtTogether' | 'relatedProducts'; context: string }
    fetchAndAddProductAvailability: (_catEntryId: string) => void
  }): Promise<PlpProduct[]> {
    if (algoliaRecommandation) {
      return AlgoliaFeaturedProductsCarousel.fetchFeaturedProducts({
        algoliaRecommandation,
        partNumber,
        fetchAndAddProductAvailability,
      })
    }

    return WcsFeaturedProductsCarousel.fetchFeaturedProducts({
      catalogEntries,
      fetchAndAddProductAvailability,
    })
  }
}

export default new FeaturedProductsCarousel()
